import { Decoration, ViewPlugin, EditorView } from '@codemirror/view';
import { getCommentLineRanges, overlapsCommentRange } from './commentUtils.js';

// Define the core patent claim words we want to highlight
// Note: for comprise/consist/correspond, we match all word forms
const _patentCoreWords = new Set(['comprise', 'consist', 'correspond', 'each', 'wherein', 'said', 'said', 'the', 'based on']);

// Create decoration for highlighted core words
const coreWordMark = Decoration.mark({
  class: "cm-patent-core-word"
});

// Create the highlighting plugin
const patentCoreHighlighter = ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.highlight(view);
  }

  update(update) {
    if (update.docChanged || update.viewportChanged)
      this.decorations = this.highlight(update.view);
  }

  highlight(view) {
    const builder = new Array();
    
    // Get comment ranges to exclude from highlighting
    const commentRanges = getCommentLineRanges(view);
    
    // Get the entire document range if visibleRanges is empty
    const from = 0;
    const to = view.state.doc.length;
    const text = view.state.doc.sliceString(from, to);
    
    // Find all core words - now including word forms for comprise/consist/correspond
    const regex = /\b(compris(?:e|es|ing|ed)|consist(?:s|ing|ed)?|correspond(?:s|ing|ed)?|each|wherein|said|the|based on)\b/gi;
    let match;
    while ((match = regex.exec(text)) !== null) {
      const start = from + match.index;
      const end = start + match[0].length;
      
      // Skip if this match is within a comment line
      if (!overlapsCommentRange(start, end, commentRanges)) {
        builder.push(coreWordMark.range(start, end));
      }
    }
    
    return Decoration.set(builder);
  }
}, {
  decorations: v => v.decorations
});

// Add the highlighting styles
const patentCoreStyles = EditorView.baseTheme({
  ".cm-patent-core-word": {
    color: "var(--color-patent-keyword)",
    fontWeight: "bold"
  }
});

// Export the extension
export const patentCoreExtension = [
  patentCoreHighlighter,
  patentCoreStyles
];
